import { Assistant } from "@/generated";
import { IMenuEntry } from "../UI/NoxusMenu";
import { useSpotUser } from "@/utils/spotUser";
import {
  ArchiveRestore,
  Copy,
  ExternalLink,
  Pencil,
  Trash2,
  Upload,
} from "lucide-react";
import { WORKSPACE_PERMISSIONS } from "@/constants/permissions";

export const useAssistantTableContextMenu = ({
  selectedStatus,
  setDeleteModelOpen,
  openAssistant,
  editAssistant,
  duplicateAssistant,
  restoreAssistant,
  exportAssistant,
}: {
  selectedStatus: {
    label: string;
    value: string;
  };
  setDeleteModelOpen: (value: boolean) => void;
  openAssistant: (id: string) => void;
  editAssistant: (assistant: Assistant) => void;
  duplicateAssistant: (assistant: Assistant) => void;
  restoreAssistant: (id: string) => void;
  exportAssistant: (assistant: Assistant) => void;
}) => {
  const getContextMenuItems = (assistant: Assistant): IMenuEntry[] => {
    if (selectedStatus.value === "deleted") {
      return [
        {
          label: "Restore",
          icon: ArchiveRestore,
          onClick: () => {
            restoreAssistant(assistant.id);
          },
        },
      ];
    }

    const items: IMenuEntry[] = [
      {
        label: "Open in New Tab",
        onClick: () => openAssistant(assistant.id),
        icon: ExternalLink,
      },
      {
        label: "Edit info",
        onClick: () => editAssistant(assistant),
        icon: Pencil,
        auth: {
          level: "group",
          permissions: [WORKSPACE_PERMISSIONS.EDIT],
          requiresAllPermissions: false,
        },
      },
      {
        label: "Duplicate",
        onClick: () => {
          duplicateAssistant(assistant);
        },
        auth: {
          level: "group",
          permissions: [WORKSPACE_PERMISSIONS.EDIT],
          requiresAllPermissions: false,
        },
        icon: Copy,
      },
      {
        label: "Export",
        onClick: () => {
          exportAssistant(assistant);
        },
        icon: Upload,
        auth: {
          level: "group",
          permissions: [WORKSPACE_PERMISSIONS.EDIT],
          requiresAllPermissions: false,
        },
      },

      {
        label: "Delete",
        onClick: () => {
          setDeleteModelOpen(true);
        },
        auth: {
          level: "group",
          permissions: [WORKSPACE_PERMISSIONS.DELETE],
          requiresAllPermissions: false,
        },
        color: "destructive",
        icon: Trash2,
      },
    ];

    return items;
  };

  return { getContextMenuItems };
};
